import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { NotificationSubscriptionForm } from "./NotificationSubscriptionForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FormToolbar } from "../../common/form/FormToolbar";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { protectedEntities } from "../../../common/auth/permissions";

interface INotificationSubscriptionCreateProps {}

export const NotificationSubscriptionEdit = (
  props: INotificationSubscriptionCreateProps
) => {
  const permissions = useActionPermissions();
  const notify = useNotification(props, "editSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.NotificationSubscription,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-notifications.title.edit">
        <NotificationSubscriptionForm
          toolbar={
            <FormToolbar
              showDeleteButton={
                permissions &&
                permissions[permissionNames.admin.notifications.main] &&
                permissions[permissionNames.admin.notifications.delete]
              }
            />
          }
        />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
